import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/terms")({
  head: () => ({
    meta: [
      { title: "Terms of Service · Buddha KA" },
      { name: "description", content: "The terms that govern your use of buddhaka.com and KAfrequency services." },
      { property: "og:title", content: "Terms of Service · Buddha KA" },
      { property: "og:description", content: "Terms governing use of Buddha KA and KAfrequency." },
      { property: "og:url", content: "https://buddhaka.com/terms" },
    ],
    links: [{ rel: "canonical", href: "https://buddhaka.com/terms" }],
  }),
  component: TermsPage,
});

function TermsPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24">
      <p className="text-xs uppercase tracking-[0.3em] text-gold">Legal</p>
      <h1 className="mt-4 font-serif text-5xl">Terms of Service</h1>
      <p className="mt-3 text-xs text-muted-foreground">Last updated: July 15, 2026</p>

      <div className="mt-10 space-y-6 text-sm leading-relaxed text-muted-foreground">
        <p>By accessing buddhaka.com or purchasing from Buddha KA and KAfrequency, you agree to these Terms.</p>

        <h2 className="font-serif text-2xl text-foreground">1. Your account</h2>
        <p>You are responsible for keeping your account credentials confidential and for all activity under your account. You must be at least 13 years old (or the age of digital consent in your country) to create an account.</p>

        <h2 className="font-serif text-2xl text-foreground">2. Purchases</h2>
        <p>All prices are shown in USD unless otherwise noted. Payment is processed by Stripe. Physical goods are shipped from our fulfillment partners; delivery timelines are estimates. Digital products (music, books, meditations) are licensed, not sold — see Section 4.</p>

        <h2 className="font-serif text-2xl text-foreground">3. Subscriptions</h2>
        <p>Memberships (KAfrequency Membership, Inner Circle) renew automatically at the interval displayed at checkout until canceled. You may upgrade, downgrade, cancel, or reactivate at any time from your account dashboard. Cancellations take effect at the end of the current billing period; we do not pro-rate partial periods. The Lifetime Ascension Pass is a one-time purchase granting lifetime access on the terms in effect at purchase.</p>

        <h2 className="font-serif text-2xl text-foreground">4. Digital content license</h2>
        <p>Purchased music, books, meditations, and other digital products are licensed to you for personal, non-commercial use. You may not redistribute, resell, remix, sync, or publicly broadcast them without written permission. Membership-only content requires an active membership — access ends when the membership ends. Purchased downloads remain yours permanently.</p>

        <h2 className="font-serif text-2xl text-foreground">5. Acceptable use</h2>
        <ul className="list-disc space-y-1 pl-6">
          <li>No unauthorized scraping, reverse engineering, or automated access.</li>
          <li>No impersonation, harassment, or unlawful conduct.</li>
          <li>No circumventing access controls or DRM.</li>
        </ul>

        <h2 className="font-serif text-2xl text-foreground">6. Intellectual property</h2>
        <p>All music, artwork, writing, and marks on the site are owned by Buddha KA or licensed to us. Nothing on the site transfers ownership.</p>

        <h2 className="font-serif text-2xl text-foreground">7. Disclaimers</h2>
        <p>Content is provided "as is". KAfrequency activations, meditations, and teachings are not medical, psychological, financial, or legal advice. Consult qualified professionals for those concerns.</p>

        <h2 className="font-serif text-2xl text-foreground">8. Limitation of liability</h2>
        <p>To the maximum extent permitted by law, our aggregate liability for any claim is limited to the amount you paid us in the twelve months preceding the claim.</p>

        <h2 className="font-serif text-2xl text-foreground">9. Termination</h2>
        <p>We may suspend or terminate accounts that violate these Terms. You may close your account at any time.</p>

        <h2 className="font-serif text-2xl text-foreground">10. Governing law</h2>
        <p>These Terms are governed by the laws of the United States and the state in which Buddha KA is registered, without regard to conflict-of-laws principles.</p>

        <h2 className="font-serif text-2xl text-foreground">11. Contact</h2>
        <p><a className="text-gold underline" href="mailto:support@buddhaka.com">support@buddhaka.com</a></p>
      </div>
    </div>
  );
}
